/**
 * @type {string[]} contains all the quarters from 2007 Q2 until 2020 Q4
 */
const Quarters = [
    "2007-Q2",
    "2007-Q3",
    "2007-Q4",
    "2008-Q1",
    "2008-Q2",
    "2008-Q3",
    "2008-Q4",
    "2009-Q1",
    "2009-Q2",
    "2009-Q3",
    "2009-Q4",
    "2010-Q1",
    "2010-Q2",
    "2010-Q3",
    "2010-Q4",
    "2011-Q1",
    "2011-Q2",
    "2011-Q3",
    "2011-Q4",
    "2012-Q1",
    "2012-Q2",
    "2012-Q3",
    "2012-Q4",
    "2013-Q1",
    "2013-Q2",
    "2013-Q3",
    "2013-Q4",
    "2014-Q1",
    "2014-Q2",
    "2014-Q3",
    "2014-Q4",
    "2015-Q1",
    "2015-Q2",
    "2015-Q3",
    "2015-Q4",
    "2016-Q1",
    "2016-Q2",
    "2016-Q3",
    "2016-Q4",
    "2017-Q1",
    "2017-Q2",
    "2017-Q3",
    "2017-Q4",
    "2018-Q1",
    "2018-Q2",
    "2018-Q3",
    "2018-Q4",
    "2019-Q1",
    "2019-Q2",
    "2019-Q3",
    "2019-Q4",
    "2020-Q1",
    "2020-Q2",
    "2020-Q3",
    "2020-Q4",
];

export default Quarters;
